import { createAction } from 'typesafe-actions'

import { User } from 'src/types'

import { UsersActionTypes } from './types'

export const getUsers = createAction(
  UsersActionTypes.GET_USERS,
  action => (search?: string) => action({ search })
)

export const getUsersSuccess = createAction(
  UsersActionTypes.GET_USERS_SUCCESS,
  action => (list: User[]) => action({ list })
)

export const getUsersFailure = createAction(
  UsersActionTypes.GET_USERS_FAILURE,
  action => () => action()
)
